module.exports = __webpack_public_path__ + "static/img/liucheng.4cdad28f.png";